/**
 * Decrementa o valor atual em 1.
 *
 * @param {number|string} x - Valor atual.
 * @returns {number}
 */
export function dec(x) {
  return Number(x) - 1;
}
